import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query'
import {
  CreditCardOfferData,
  MutateCreditCardOfferArgs,
  mutateCreditCardOffer,
  queryCreditCardOffer,
} from '../api'
import { useHostServices } from '../HostServices'

export const useCreditCardOfferQuery = (): UseQueryResult<{
  customerCardOffer: CreditCardOfferData
}> => {
  const { featureFlags, session } = useHostServices()
  const isCreditCardCrossSellEnabled = featureFlags.variation(
    'FF_credit-card-cross-sell',
    false,
  )
  const guid = session.data?.guid
  const accessToken = session.data?.access_token

  return useQuery(
    ['credit-card-offer'],
    () => {
      return queryCreditCardOffer({
        guid: guid ?? '',
        accessToken: accessToken ?? '',
      })
    },
    {
      enabled: Boolean(isCreditCardCrossSellEnabled && guid && accessToken),
    },
  )
}

export const useCreditCardOfferMutation = (): UseMutationResult<
  boolean,
  Error,
  MutateCreditCardOfferArgs
> => {
  return useMutation({
    mutationFn: mutateCreditCardOffer,
  })
}
